import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=cafa87b8&scoped=true&"
import script from "./pc.vue?vue&type=script&lang=js&"
export * from "./pc.vue?vue&type=script&lang=js&"
import style0 from "./pc.vue?vue&type=style&index=0&id=cafa87b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafa87b8",
  null
  
)

export default component.exports